const notificationCategories = {
    AUTO_OPTIMIZATION_APPLIED: 'AUTO_OPTIMIZATION.applied',
    AUTO_OPTIMIZATION_INCOMPLETE: 'AUTO_OPTIMIZATION.incomplete',
    AUTO_OPTIMIZATION_STOPPED: 'AUTO_OPTIMIZATION.stopped',
    DEAL_READY: 'DEAL.ready',
    DEAL_PAUSED: 'DEAL.paused',
    DEAL_UNPAUSED: 'DEAL.unpaused',
    DEAL_WILL_BE_PAUSED: 'DEAL.will_be_paused',
    SUPPORT_REQUEST: 'SUPPORT.request',
    EVENT_AUDIT_INACTIVE: 'EVENT_AUDIT.inactive',
    OPTIMISE_REPORT_READY: 'OPTIMISE_REPORT.ready',
    EVENT_LOG_REPORT_READY: 'EVENT_LOG_REPORT.ready',
    VIDEO_REPORT_READY: 'VIDEO_REPORT.ready',
};
export default notificationCategories;

export const notificationCategoryGroups = {
    ALL: 'All',

    DEAL_IDS: 'Deal IDs',
    INSIGHTS: 'Pulse Reports',
    CONTEXTS: 'Contexts',
    SUPPORT: 'Support',
};

export const notificationCategoryTypes = [
    // Deal IDs:
    {
        id: notificationCategories.DEAL_READY,
        group: notificationCategoryGroups.DEAL_IDS,
        settingId: 'notifications_deal_ready',
        label: 'New deal ID ready',
        supportsInApp: true,
        supportsEmail: true,
    },
    {
        id: notificationCategories.DEAL_PAUSED,
        group: notificationCategoryGroups.DEAL_IDS,
        settingId: 'notifications_deal_paused',
        label: 'Deal paused due to inactivity',
        supportsInApp: true,
        supportsEmail: true,
    },
    {
        id: notificationCategories.DEAL_UNPAUSED,
        group: notificationCategoryGroups.DEAL_IDS,
        settingId: 'notifications_deal_reactivated',
        label: 'Deal reactivated',
        supportsInApp: true,
        supportsEmail: true,
    },
    {
        id: notificationCategories.DEAL_WILL_BE_PAUSED,
        group: notificationCategoryGroups.DEAL_IDS,
        settingId: 'notifications_deal_pause_warning',
        label: 'Deal about to be paused due to inactivity',
        supportsInApp: true,
        supportsEmail: true,
    },

    // Insights:
    {
        id: notificationCategories.OPTIMISE_REPORT_READY,
        group: notificationCategoryGroups.INSIGHTS,
        settingId: 'notifications_insights_display_ready',
        label: 'Display insights report ready',
        supportsInApp: true,
        supportsEmail: true,
    },
    {
        id: notificationCategories.VIDEO_REPORT_READY,
        group: notificationCategoryGroups.INSIGHTS,
        settingId: 'notifications_insights_video_ready',
        label: 'Video insights report ready',
        supportsInApp: true,
        supportsEmail: true,
    },
    {
        id: notificationCategories.EVENT_LOG_REPORT_READY,
        group: notificationCategoryGroups.INSIGHTS,
        settingId: 'notifications_event_log_ready',
        label: 'Event log report ready',
        supportsInApp: true,
        supportsEmail: true,
    },
    {
        id: notificationCategories.EVENT_AUDIT_INACTIVE,
        group: notificationCategoryGroups.INSIGHTS,
        settingId: `notifications_insights_tag_anomaly`,
        label: '4D Tag needs reapplying',
        supportsInApp: true,
        supportsEmail: true,
    },

    // Contexts:
    {
        id: notificationCategories.AUTO_OPTIMIZATION_APPLIED,
        group: notificationCategoryGroups.CONTEXTS,
        settingId: 'notifications_auto_optimization_applied',
        label: 'AutoPilot opmtimized a context',
        supportsInApp: true,
        supportsEmail: true,
    },
    {
        id: notificationCategories.AUTO_OPTIMIZATION_INCOMPLETE,
        group: notificationCategoryGroups.CONTEXTS,
        settingId: 'notifications_auto_optimization_incomplete',
        label: 'Incomplete AutoPilot setup',
        supportsInApp: true,
        supportsEmail: true,
    },
    {
        id: notificationCategories.AUTO_OPTIMIZATION_STOPPED,
        group: notificationCategoryGroups.CONTEXTS,
        settingId: 'notifications_auto_optimization_stopped',
        label: 'AutoPilot was stopped for a context',
        supportsInApp: true,
        supportsEmail: true,
    },

    // Support:
    {
        id: notificationCategories.SUPPORT_REQUEST,
        group: notificationCategoryGroups.SUPPORT,
        settingId: `notifications_support_request`,
        label: 'Support request received',
        supportsInApp: true,
        supportsEmail: true,
    },
];
